import { ButtonV3, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { Dispatch, SetStateAction } from 'react';

export interface EmailSubmittedContentProps {
  readonly onClick: Dispatch<SetStateAction<boolean>>;
}

const EmailSubmittedContent = ({
  onClick,
}: EmailSubmittedContentProps): JSX.Element => {
  const t = useTranslations();

  return (
    <div className="pt-2">
      <TypographyV3 color="inherit" className="text-center text-xl">
        {t('inventory_notify_module_exit_title')}
      </TypographyV3>
      <TypographyV3 color="inherit" className="px-10 py-5 text-center text-lg">
        {t('inventory_notify_module_exit_subtext')}
      </TypographyV3>
      <ButtonV3
        className="min-w-full"
        data-cy="notifyModalContinueShoppingCTA"
        name="continueShopping"
        onClick={() => onClick((val) => !val)}
        type="button"
      >
        {t('inventory_notify_module_continue_shopping')}
      </ButtonV3>
    </div>
  );
};

export default EmailSubmittedContent;
